<template>
  <div
    class="group flex items-center w-full transition duration-100 ease-in-out border rounded focus-within:ring-2 focus-within:ring-blue-500 focus-within:outline-none focus-within:ring-opacity-50"
    :class="classes"
  >
    <div class="flex items-center w-full h-full">
      <slot name="leading" />
      <input
        v-model="_value"
        class="appearance-none h-full bg-transparent w-full outline-none"
        type="number"
        :placeholder="placeholder"
        :disabled="disabled"
      >
    </div>

    <slot name="trailing" />
  </div>
</template>

<script>
import Input from '@/mixins/input.js'

export default {
  name: 'BNumberInput',
  mixins: [Input],
  props: {
    value: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
        this.$emit('change', value)
      }
    }
  }
}
</script>
